import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { parseChannelSettingsTabParam } from '../components/ChannelSettings/channelSettingsTabs';

/**
 * Resolves `/channels/:channelId/:tab` into the thread page with settings drawer open.
 * e.g. `/channels/abc-123/automation` → `/threads/abc-123?openSettings=true&tab=automation`
 */
const ChannelSettingsTabRedirect: React.FC = () => {
  const { channelId, tab } = useParams<{ channelId: string; tab: string }>();

  if (!channelId) {
    return <Navigate to="/supportSpace" replace />;
  }

  const tabId = parseChannelSettingsTabParam(tab) ?? 'config';
  const search = new URLSearchParams({
    openSettings: 'true',
    tab: tabId,
  });

  return <Navigate to={`/threads/${channelId}?${search.toString()}`} replace />;
};

export default ChannelSettingsTabRedirect;
